import SearchClass from '../../lib/search/SearchClass';
import MapClass from '../../lib/map/Map';
import {setSubPrefectureAccordionButtonEvent} from "../../lib/search/search";

/**
 * Get the URL parameter value
 *
 * @param  name {string} パラメータのキー文字列
 * @return  url {url} 対象のURL文字列（任意）
 */
function getParam(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

/*******************************************/
/****************** MAP展開 *****************/
/*******************************************/

// MAP の中央位置（都道府県、市区町村）を取得
const currentPrefectureElement = document.querySelector('[data-current-prefecture]');
const currentCityElement = document.querySelector('[data-current-city]');
const currentPrefecture = currentPrefectureElement?.getAttribute('data-current-prefecture') ?? defaultPrefecture;
const currentCity = currentCityElement?.getAttribute('data-current-city');

// MAP の展開
const Map = new MapClass(currentPrefecture, currentCity, currentPrefectureElement === null);
(async () => {
  // 共通の検索条件をクエリパラメータから取得
  searchInit();

  // MAP の初期化
  await Map.start();

  // 共通の検索条件で表示する物件を絞り込み
  await Map.handleMapSubmit();
})();

$(function () {
  $('[data-city-search]').on('click', function () {
    const preCityElement = document.querySelector('[data-current-city]');

    // 現在アクティブな市区名を非アクティブに変更する
    preCityElement && preCityElement.classList.remove('active');
    preCityElement && preCityElement.removeAttribute('data-current-city');

    // クリックされた市区名をアクティブに変更する
    this.classList.add('active');
    this.setAttribute('data-current-city', this.getAttribute('data-city-name'));

    const cityName = Map.concatAddress(currentPrefecture, this.dataset.cityName);
    (async () => {
      await Map.mapInit({"zoom_level": 15, "map_word": cityName});
    })();
  });
})

/*******************************************/
/****************** リンク *****************/
/*******************************************/
$(function () {
  $(document).on('click', '[data-link-service-brand]', function () {
    const serviceBrandId = this.value;
    const serviceBrandIdCheckbox = $('[name="service_brand[]"][value=' + serviceBrandId + ']');
    if (!serviceBrandIdCheckbox.prop('checked')) {
      serviceBrandIdCheckbox.prop('checked', true).trigger('change');
      // 再検索
      Map.quickSubmit();
    }
  });
})

/*******************************************/
/******** 条件絞り込みモーダルオープン時 ********/
/*******************************************/
!function () {
  document.querySelector('[data-search-modal-open]').onclick = function () {
    new SearchClass().count(new SearchClass().getInput());
  }
}();

/**
 * 都道府県リンクのクリックイベント
 *
 * 都道府県リンクがクリックされた際に都道府県をクエリパラメータに追加してページ遷移するイベントを追加
 */
!function () {
  prefectureLinkOnClick();

  // 全ての都道府県を見るボタンクリックごとに主要都道府県以外の表示・非表示を切り替えるイベントを登録
  setSubPrefectureAccordionButtonEvent();
}();

/**
 * 検索条件の初期化
 *
 * URLパラメータを元に検索条件のチェックボックスを初期化する
 */
function searchInit() {
  // 共通条件のチェックボックスを取得
  const commonConditionCheckboxes = document.querySelectorAll('[data-search-common-conditions] input[type="checkbox"]');

  // クエリパラメータから共通条件を取得
  const commonConditions = new URLSearchParams(location.search).getAll('common[]');
  const capacityCategoryConditions = new URLSearchParams(location.search).getAll('capacity_category[]');
  const budgetCategoryConditions = new URLSearchParams(location.search).getAll('budget_category[]');
  const serviceBrandConditions = new URLSearchParams(location.search).getAll('service_brand[]');

  // クエリパラメータから取得した共通条件をチェックボックスに反映する関数
  const checkIfSomeEqual = (ary, value, checkbox, category) => {
    const hasCategoryMatch = checkbox.name === category;
    const hasValueInAry = ary.some((item) => item === value);

    // チェックボックスの値がクエリパラメータに含まれており、カテゴリがある場合はそれが一致している場合にチェックを入れる
    if (hasValueInAry && (!category || hasCategoryMatch)) {
      checkbox.checked = true;
      new SearchClass().appendSearchTag(checkbox.name.replace(/\[\]$/, ''), checkbox.title, checkbox.value);
    }
  }

  // 共通条件のチェックボックスとクエリパラメータを比較してチェックを入れる
  commonConditionCheckboxes.forEach((checkbox) => {
    if (checkbox.checked) {
      return;
    }

    checkIfSomeEqual(commonConditions, checkbox.name, checkbox);
    checkIfSomeEqual(capacityCategoryConditions, checkbox.value, checkbox, 'capacity_category[]');
    checkIfSomeEqual(budgetCategoryConditions, checkbox.value, checkbox, 'budget_category[]');
    checkIfSomeEqual(serviceBrandConditions, checkbox.value, checkbox, 'service_brand[]');
  });
}

/**
 * 都道府県リンクがクリックされた際の動作
 *
 * 都道府県リンクがクリックされた際に、都道府県をクエリパラメータに追加してページ遷移する
 */
function prefectureLinkOnClick() {
  // 都道府県リンクがクリックされた際の動作
  document.querySelectorAll('#search_condition_prefecture [data-change-prefecture]').forEach((link) => {
    link.addEventListener('click', (event) => {
      // デフォルトでついているイベントを実行しない
      event.preventDefault();

      // チェックされている要素を取得する
      const conditions = new SearchClass().getInput();

      // 条件をクエリパラメータに追加する
      const params = new URLSearchParams();
      for (const key in conditions) {
        // 都道府県はクエリパラメータに追加しない
        if (key === 'prefecture') {
          continue;
        }

        // キーがカテゴリ名で値が配列の場合は {カテゴリ名}[] に追加
        if (conditions[key] instanceof Array) {
          conditions[key].forEach((value) => {
            params.append(key + '[]', value);
          });
        }
        // キーが値の場合は common[] に追加
        else {
          params.append('common[]', key);
        }
      }

      // モバイルサイズとそれ以外でページ内リンクのスクロール先を変える
      const targetDataset = window.innerWidth > 767 ? 'data-anchor' : 'data-mobile-anchor';

      // クエリパラメータをつけた状態でクリックされた都道府県にページ遷移する
      location.href = link.getAttribute('data-change-prefecture') + '?' + params.toString() + '#' + link.getAttribute(targetDataset);
    });
  });
}
